import { useEffect, useRef, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Capabilities } from "@/components/site/Capabilities";
import { Industries } from "@/components/site/Industries";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, lerp: 0.09 });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onScrollTo = (e) => {
      if (e.detail) lenis.scrollTo(e.detail, { offset: -74, duration: 1.2 });
    };
    window.addEventListener("lenis-scroll-to", onScrollTo);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("lenis-scroll-to", onScrollTo);
      lenis.destroy();
    };
  }, []);

  const scrollToQuote = useCallback(() => {
    const el = document.getElementById("contact");
    if (el && lenisRef.current) lenisRef.current.scrollTo(el, { offset: -74, duration: 1.2 });
  }, []);

  return (
    <div className="App bg-background min-h-screen">
      <div className="grain" />
      <Nav onQuote={scrollToQuote} />
      <main>
        <Hero onQuote={scrollToQuote} />
        <Marquee />
        <Manifesto />
        <Capabilities onQuote={scrollToQuote} />
        <Industries />
        <QuoteForm />
      </main>
      <Footer onQuote={scrollToQuote} />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
